import { faSpinner } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

interface LoadingItemProps {
    height?: number;
    className?: string;
}

// 🎯 Componente presentacional para items de carga - SRP
export const LoadingItem: React.FC<LoadingItemProps> = ({
    height = 60,
    className = ''
}) => {
    return (
        <div
            className={`w-full flex items-center justify-center ${className}`}
            style={{ height: `${height}px` }}
        >
            <div className="flex items-center gap-2 text-muted-foreground">
                <FontAwesomeIcon
                    icon={faSpinner}
                    className="animate-spin text-sm"
                />
                <span className="text-sm">Cargando...</span>
            </div>
        </div>
    );
}; 